import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Clock, CreditCard, ArrowRight } from 'lucide-react';

export default function TrialExpired() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8">
      <Card className="max-w-md w-full border-0 shadow-xl">
        <CardContent className="pt-12 pb-8 px-8 text-center">
          <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Clock className="w-10 h-10 text-amber-600" />
          </div>
          
          <h1 className="text-2xl font-bold mb-3" data-testid="trial-expired-title">
            Período de Teste Encerrado
          </h1>
          
          <p className="text-muted-foreground mb-8 leading-relaxed">
            Seus 7 dias de teste gratuito terminaram. Para continuar usando a plataforma 
            e acessar todas as suas ideias salvas, faça o pagamento.
          </p>
          
          <div className="bg-primary/5 border border-primary/20 rounded-2xl p-6 mb-8">
            <div className="flex items-center gap-3 text-left">
              <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <CreditCard className="w-5 h-5 text-primary" />
              </div>
              <div>
                <p className="font-medium text-sm">Continue aproveitando!</p>
                <p className="text-xs text-muted-foreground">
                  Faça o pagamento e tenha acesso ilimitado à plataforma.
                </p>
              </div>
            </div>
          </div>
          
          <div className="space-y-3">
            <Link to="/pagamento" data-testid="payment-link">
              <Button className="w-full h-11 rounded-full font-medium">
                Fazer Pagamento
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
            
            <Link to="/login" data-testid="back-to-login">
              <Button variant="ghost" className="w-full">
                Voltar ao Login
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
